import React from 'react';
import { Intro } from '..';
import './intros.css';

function Intros({list}) {
    var intros = list.map((intro, idx) => <Intro {...intro} key={idx} />)
    // let intros = []
    // for (let intro of props.intros) {
    //     intros.push(<Intro props={intro} />)
    // }

    return (
        <div className="main-intro">
            {intros}
        </div>
    )
}

export default Intros;